"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Heading = void 0;
var tslib_1 = require("tslib");
require("./heading.css");
var React = tslib_1.__importStar(require("react"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var defaultSize = {
    h1: 1,
    h2: 2,
    h3: 3,
    h4: 4,
    h5: 5,
    h6: 6,
    span: 5,
    p: 5,
};
/** Heading text structured in levels. */
var Heading = function (_a) {
    var _b = _a.type, type = _b === void 0 ? 'span' : _b, _c = _a.size, size = _c === void 0 ? defaultSize[type] : _c, children = _a.children, _d = _a.dataTest, dataTest = _d === void 0 ? 'heading' : _d, className = _a.className, other = tslib_1.__rest(_a, ["type", "size", "children", "dataTest", "className"]);
    var classes = (0, classnames_1.default)('dsc-heading', size === 1 || size === 2 || size === 3 || size === 4 || size === 5 || size === 6 ? "has-size0".concat(size) : null, typeof size === 'string' && size.includes('display') && size, size === 'eyebrow' && size, className);
    return React.createElement(type, tslib_1.__assign(tslib_1.__assign({}, other), { className: classes, 'data-test': dataTest }), children);
};
exports.Heading = Heading;
exports.Heading.displayName = 'Heading';
//# sourceMappingURL=heading.js.map